import React from 'react'
import styles from './Techstack.module.css'

export default function TechStack() {
  return (
    <div id={styles.techstackPage}>
      <div id={styles.techstackContainer}>
        <div className={styles.cards}>
          <img src="/IconJ-png/html.png" alt="html icon" />
          <p> HTML </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/css.png" alt="css icon" />
          <p> CSS </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/Javascript.png" alt="javascript icon" />
          <p> JavaScript </p>
        </div>

        {/* <div className={styles.cards}>
            <img src="/IconJ-png/tailwind.png" alt="" />
            <p> Tailwind </p>
        </div> */}

        <div className={styles.cards}>
          <img src="/IconJ-png/typescript.png" alt="typescript icon" />
          <p> TypeScript </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/react.png" alt="react icon" />
          <p> React </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/nodeJS.png" alt="Node.JS icon" />
          <p> Node.JS </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/ex.png" alt="Express icon" />
          <p> Express </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/postgres.png" alt="Postgres SQL icon" />

          <p> Postgres SQL </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/jest.png" alt="ject icon" />
          <p> Jest </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/cypress.png" alt="cypress icon" />
          <p> Cypress </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/playwright.png" alt="playwright icon" />
          <p> Playwright </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/figma.png" alt="figma icon" />
          <p> Figma </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/netlify.jpg" alt="netlify icon" />
          <p> Netlify </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/render.jpg" alt="render icon" />
          <p> Render </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/git.png" alt="git icon" />
          <p> Git </p>
        </div>

        <div className={styles.cards}>
          <img src="/IconJ-png/powerbi.png" alt="git icon" />
          <p> Power BI </p>
        </div>
      </div>
    </div>
  );
}
